import { makeObservable, observable } from 'mobx'

import { LocationType } from '~/client/graph'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'

import FieldIds from '../../enums/DeliveryFieldIds'
import IHierarchyParent from '../../types/IHierarchyParent'
import ILocationAttributeDto, {
  IWorkflowRestrictions,
} from '../../types/ILocationAttributeDto'
import IMsDateInterval from '../../types/IMsDateInterval'
import LocationAttributeBase from './LocationAttributeBase'

export interface IProjectLocationDto extends ILocationAttributeDto {
  isLinked?: boolean
}

export default class ProjectLocation extends LocationAttributeBase<ProjectLocation> {
  public constructor(
    id: string,
    name: string,
    color: string,
    iconName: MapViewLocationIcon,
    projectId: string,
    code?: string,
    operatingIntervals?: IMsDateInterval[],
    parent?: IHierarchyParent,
    permittedCompanies?: string[],
    isDeleted?: boolean,
    assignedSitemaps?: string[],
    assignedGlobes?: string[],
    maxBookingDuration?: number,
    maxOverlappingDeliveries?: number,
    workflowRestrictions?: IWorkflowRestrictions,
  ) {
    super(
      id,
      name,
      color,
      iconName,
      projectId,
      code,
      operatingIntervals,
      parent,
      permittedCompanies,
      isDeleted,
      assignedSitemaps,
      assignedGlobes,
      maxBookingDuration,
      maxOverlappingDeliveries,
      workflowRestrictions,
    )

    makeObservable(this)
  }

  public static fromDto(dto: IProjectLocationDto): ProjectLocation {
    const item = LocationAttributeBase.factory(
      ProjectLocation,
      dto,
      MapViewLocationIcon.Project,
    )
    item.isLinked = dto.isLinked ?? true

    return item
  }

  @observable public isLinked: boolean = true

  public type = LocationType.ProjectLocation
  protected relatedFieldId = FieldIds.PROJECT
  protected model = ProjectLocation

  public isEqual(dto: ProjectLocation) {
    return super.isEqual(dto) && this.isLinked === dto.isLinked
  }

  public copy(): ProjectLocation {
    const item = super.copy()

    item.isLinked = this.isLinked

    return item
  }

  public getDto(): IProjectLocationDto {
    const dto: IProjectLocationDto = super.getDto()

    dto.isLinked = this.isLinked

    return dto
  }
}
